import { render } from "./ProsesInfografis.vue?vue&type=template&id=50f026b6"
import script from "./ProsesInfografis.vue?vue&type=script&lang=js"
export * from "./ProsesInfografis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__